// 保障人员
import request from '@/utils/util.js'

// 列表
export function getEscortsAPI(data) {
	return request.get('/car/guarantee/nursing_workers', data)
}
